(function () {
  'use strict';

  // Módulo independente para ordenação via AJAX por year_order
  var isLoading = false;
  var observer = null;

  function findReorderButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('.posts-reorder'));
  }

  function findNavPrevLink() {
    return document.querySelector('.navigation.posts-navigation .nav-previous a');
  }

  function findNavContainer() {
    return document.querySelector('.navigation.posts-navigation');
  }

  function findPostsContainer() {
    return document.querySelector('.posts-container');
  }

  function resolveUrl(href) {
    try {
      return new URL(href, window.location.href).href;
    } catch (e) {
      return href;
    }
  }

  function setNavLoading(on) {
    var nav = findNavContainer();
    if (!nav) return;
    if (on) nav.classList.add('loading');
    else nav.classList.remove('loading');
  }

  function buildUrlWithYearOrder(order) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('year_order', order);
      return url.href;
    } catch (e) {
      // Fallback simples concatenando (menos robusto)
      var href = window.location.href.split('#')[0];
      var parts = href.split('?');
      var base = parts[0];
      var qs = parts[1] || '';
      var params = new URLSearchParams(qs);
      params.set('year_order', order);
      return base + '?' + params.toString();
    }
  }

  function replacePostsAndNavFromDocument(doc) {
    var newPosts = doc.querySelector('.posts-container');
    var posts = findPostsContainer();
    if (newPosts && posts) {
      posts.innerHTML = newPosts.innerHTML;
    }

    var newNav = doc.querySelector('.navigation.posts-navigation');
    var nav = findNavContainer();
    if (newNav) {
      if (nav && nav.parentNode) {
        var clone = newNav.cloneNode(true);
        nav.parentNode.replaceChild(clone, nav);
      }
    } else if (nav && nav.parentNode) {
      nav.parentNode.removeChild(nav);
    }
  }

  function appendArticlesFromDocument(doc) {
    var newPostsContainer = doc.querySelector('.posts-container');
    var postsContainer = findPostsContainer();
    if (!postsContainer || !newPostsContainer) return 0;
    var articles = newPostsContainer.querySelectorAll('article');
    var count = 0;
    Array.prototype.forEach.call(articles, function (article) {
      var clone = article.cloneNode(true);
      postsContainer.appendChild(clone);
      count++;
    });
    return count;
  }

  function fetchHtml(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (resp) {
      if (!resp.ok) throw new Error('Network response was not ok');
      return resp.text();
    });
  }

  function fetchAndReplace(url, onComplete) {
    isLoading = true;
    setNavLoading(true);
    fetchHtml(url)
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        replacePostsAndNavFromDocument(doc);
        if (typeof onComplete === 'function') onComplete(null, doc);
      })
      .catch(function (err) {
        if (typeof onComplete === 'function') onComplete(err);
      })
      .finally(function () {
        isLoading = false;
        setNavLoading(false);
      });
  }

  // IMPLEMENTAÇÃO DE INFINITE SCROLL LOCAL (independente)
  function disconnectObserver() {
    if (observer && typeof observer.disconnect === 'function') {
      try {
        observer.disconnect();
      } catch (e) {}
    }
    observer = null;
  }

  function initInfiniteScrollForNav() {
    disconnectObserver();
    var link = findNavPrevLink();
    if (!link) return;

    var options = { root: null, rootMargin: '0px 0px 10px 0px', threshold: 0 };

    function onIntersect(entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          var currentLink = findNavPrevLink();
          if (!currentLink) {
            disconnectObserver();
            return;
          }
          var href = currentLink.getAttribute('href');
          if (!href || isLoading) return;
          observer.unobserve(entry.target);
          isLoading = true;
          setNavLoading(true);
          fetchHtml(resolveUrl(href))
            .then(function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              appendArticlesFromDocument(doc);
              // Atualiza nav para próxima página
              var newNavLink = doc.querySelector('.navigation.posts-navigation .nav-previous a');
              var navContainer = findNavContainer();
              var newNav = doc.querySelector('.navigation.posts-navigation');
              if (newNav) {
                if (navContainer && navContainer.parentNode) {
                  var clone = newNav.cloneNode(true);
                  navContainer.parentNode.replaceChild(clone, navContainer);
                }
              } else if (navContainer && navContainer.parentNode) {
                navContainer.parentNode.removeChild(navContainer);
              }
            })
            .catch(function () {})
            .finally(function () {
              isLoading = false;
              setNavLoading(false);
              // Re-observe new link if exists
              var navLink = findNavPrevLink();
              if (navLink && observer) {
                try {
                  observer.observe(navLink);
                } catch (e) {}
              }
            });
        }
      });
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(onIntersect, options);
      try {
        observer.observe(link);
      } catch (e) {}
    } else {
      // Fallback: listener de scroll
      var onScroll = function () {
        if (isLoading) return;
        var rect = link.getBoundingClientRect();
        if (rect.top - window.innerHeight <= 10) {
          window.removeEventListener('scroll', onScroll);
          var href = link.getAttribute('href');
          if (!href) return;
          isLoading = true;
          setNavLoading(true);
          fetchHtml(resolveUrl(href))
            .then(function (html) {
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, 'text/html');
              appendArticlesFromDocument(doc);
              var newNav = doc.querySelector('.navigation.posts-navigation');
              var navContainer = findNavContainer();
              if (newNav) {
                if (navContainer && navContainer.parentNode) {
                  var clone = newNav.cloneNode(true);
                  navContainer.parentNode.replaceChild(clone, navContainer);
                }
              } else if (navContainer && navContainer.parentNode) {
                navContainer.parentNode.removeChild(navContainer);
              }
            })
            .catch(function () {})
            .finally(function () {
              isLoading = false;
              setNavLoading(false);
              var newLink = findNavPrevLink();
              if (newLink) window.addEventListener('scroll', onScroll);
            });
        }
      };
      window.addEventListener('scroll', onScroll);
      onScroll();
    }
  }

  function handleReorderClick(e) {
    var btn = e.currentTarget;
    // Identifica estado atual sem alterar as classes 'asc'/'desc'
    var order = btn.classList.contains('asc')
      ? 'asc'
      : btn.classList.contains('desc')
        ? 'desc'
        : 'desc';

    // Marca este botão como ativo e remove 'active' dos outros
    var buttons = findReorderButtons();
    buttons.forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');

    var url = buildUrlWithYearOrder(order);
    fetchAndReplace(url, function (err) {
      if (!err) {
        // Após substituir conteúdo, inicializa nosso infinite scroll local
        initInfiniteScrollForNav();
      }
    });
  }

  function setupReorderButtons() {
    var buttons = findReorderButtons();
    if (!buttons || !buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', handleReorderClick);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupReorderButtons();
    // Inicializa infinite scroll na carga inicial também
    initInfiniteScrollForNav();
  });
})();
